// extracted by mini-css-extract-plugin
module.exports = {"history":"styles_history__12Um3"};